import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { categoryList } from '../../data/localData'
import { Link } from 'react-router-dom'

function CategoryList() {
    return (
        <div className='home-gap about-category-list'>
            <Container>
                <h2 className='m-0 fs-48 fs-md-35 fs-sm-25 text-center fw-semibold list-title'>Industries We Serve</h2>
                <Row className='gy-3'>
                    {
                        categoryList.map((category, index) => {
                            return (
                                <Col className='col-6 col-md-3 d-grid' key={index}>
                                    <div to={category.redirectLink} className='text-center p-3 category-holder align-content-end'>
                                        <img src={category.image} alt="" />
                                        <Link className='fs-25 fs-md-20 fs-sm-16 m-0 fw-semibold category-link'>{category.name}</Link>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
        </div>
    )
}

export default CategoryList